import React from 'react';
import { Box, Typography, Button } from '@mui/material';
import { useTranslation } from 'react-i18next';
import { useStyles } from './styles';

interface ThankYouScreenProps {
  onClose: () => void;
}

const ThankYouScreen: React.FC<ThankYouScreenProps> = ({ onClose }) => {
  const { t: translate } = useTranslation();
  const classes = useStyles();

  return (
    <Box sx={classes.container}>
      <Box sx={classes.closeButtonContainer}>
        <Button onClick={onClose} sx={classes.closeButton}>
          <Typography sx={classes.closeButtonText}>✕</Typography>
        </Button>
      </Box>

      <Box sx={classes.contentContainer}>
        <Typography sx={classes.title}>{translate('feedbackForm.thankYou')}</Typography>
        <Typography sx={classes.message}>{translate('feedbackForm.thankYouMessage')}</Typography>
      </Box>
    </Box>
  );
};

export default ThankYouScreen;
